export default defineNuxtRouteMiddleware((to, from) => {
  if (to.fullPath !== from.fullPath) {
    useUIStore().reset()
  }

  if (from.path && from.path !== to.path) {
    useCurrentStoryStore().reset()
  }
})
